var m = require('mithril');
var layout = require('../layout/layout');
var reports = require('./reports');
var reportDetail = require('./reportDetail');
var permissions = require('./permissions');
var reportSystem = require('./reportSystem')

module.exports = {
  '/reportfolder/:id': {
    view: function() {
      return m(layout, m(reports));
    },
  },
  '/reportfolder/:id/permissions': {
    view: function() {
      return m(layout, m(permissions));
    },
  },
  '/report/:id': {
    view: function() {
      return m(layout, m(reportDetail));
    },
  },
  '/reportsystem': {
    view: function() {
      return m(layout, m(reportSystem));
    },
  }
};